import * as React from 'react';
import {Breadcrumb, Grid, Input, Table} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
  ColumnSelectableComponentProps,
  ColumnSortableComponentProps,
  FilterObjectComponentProps,
  InfinityScrollComponentProps,
  ViewSettingsComponentProps,
  withColumnSelection,
  withColumnSort,
  withFilterObject,
  withInfinityScrollHandlers, withPrintAndExport,
  withViewSettings
} from '../../components/DataTable/dataService';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import {formatCurrency} from '../../utils/numbers';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import RestClient from '../../../../lib/RestClient';
import {useEffect, useState} from 'react';

import queryString from 'query-string';
import {dateToIsoDateString} from '../../utils/dates';
import Moment from 'react-moment';
import moment from 'moment';
import _get from "lodash/get";
import InfiniteScroll from "react-infinite-scroller";
import ExportContextHolder from "../../../../lib/ExportContextHolder";
import {useMarketName} from "../../components/MasterData/master-data-resolvers";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

const COLUMNS: ColumnDefinition[] = [
  {
    fieldName: 'data.bewegungsDatum',
    labelTranslationKey: 'Sales.datum',
    required: true,
    cellRender: v => <Moment format={t("Common.DateFormat")}>{v}</Moment>,
    printExportRender: v => moment(v).format(t("Common.DateFormat"))
  },
  {
    fieldName: 'data.kunde',
    labelTranslationKey: 'Sales.kunde',
    required: true
  },
    {
        fieldName: 'data.geschaeftsbereich',
        labelTranslationKey: 'Sales.geschaeftsbereich',
        required: true,
        cellRender: (_, row) => `${row.data && row.data.geschaeftsbereich} ${t("Fields." + row.data.geschaeftsbereich)}`
    },
  { fieldName: 'data.sorteNr2', labelTranslationKey: 'Sales.artikel',
    cellRender: (_, row) => `${row.data && row.data.sorteNr2} ${row.data && row.data.farbeNr}`,
    printExportRender: (_, row) => `${row.data && row.data.sorteNr2} ${row.data && row.data.farbeNr}`,
    required: true
  },
  {fieldName: 'data.laenge', labelTranslationKey: 'Sales.laenge', required: true},
  {fieldName: 'data.beschreibung', labelTranslationKey: 'Sales.beschreibung', required: true},
  {fieldName: 'data.gesamtAnz', labelTranslationKey: 'Sales.anzahl', cellAlign: 'right'},
  {
    fieldName: 'data.preis',
    labelTranslationKey: 'Sales.preis',
    cellAlign: 'right',
    cellRender: v => formatCurrency(v || 0),
    printExportRender: v => formatCurrency(v || 0)
  },
  {
    fieldName: 'data.gesamtWert',
    labelTranslationKey: 'Sales.gesamtWert',
    cellAlign: 'right',
    cellRender: v => formatCurrency(v || 0),
    printExportRender: v => formatCurrency(v || 0)
  },
  {fieldName: 'data.partie', labelTranslationKey: 'Sales.partie'},
  {fieldName: 'data.qualitaet', labelTranslationKey: 'Sales.qualitaet'}
];

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

const SalesSupplierDetails = (props: {dateFrom?: Date; dateTo?: Date; marketName?: string} & RouteComponentProps<{konto: string; markt: string;}> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {
  if(props.loadingInitial || !props.data) {
    return <LoadingContainer showLogo={false}/>;
  }

    let data: any = props.data;

    let rows =  data.instances && data.instances.length > 0 ? (
            <>
                {data.instances.map((row: any, idx: any) =>
                    <>
                        {row.instances.map((row_: any, idx: any) =>
                            <>
                                {row_.instances.map((row__: any, idx: any) =>
                                    <>
                                        {row__.instances.map((row___: any, idx: any) =>
                                            <>
                                                {row___.instances.map((row____: any, idx: any) =>
                                                        <Table.Row key={idx}>
                                                            {COLUMNS.map((column, colidx)=>
                                                                <Table.Cell className={"responsive" + (column.cellAlign === 'right' ? ' alignRight' : '')}>
                                                                    {column.cellRender ? column.cellRender(_get(row____, column.fieldName), row____, props.filterObject) : _get(row____, column.fieldName)}
                                                                </Table.Cell>
                                                            )}
                                                        </Table.Row>)
                                                }

                                                <Table.Row style={{backgroundColor: "rgb(249, 250, 251)", color: "rgba(0,0,0,.87)"}}>
                                                    <Table.Cell className={"responsive alignRight"} colspan={5}>
                                                        <b>{t("Sales.sum_length")} ({row___.laenge}):</b>
                                                    </Table.Cell>
                                                    <Table.Cell></Table.Cell>
                                                    <Table.Cell className={"responsive alignRight"} >{row___.gesamtAnz}</Table.Cell>
                                                    <Table.Cell className={"responsive alignRight"} >Ø {  (( (row___.gesamtWert + 0.0001).toFixed(2) /row___.gesamtAnz) + 0.0001).toFixed(2)}</Table.Cell>
                                                    <Table.Cell className={"responsive alignRight"}>
                                                        {(row___.gesamtWert + 0.0001).toFixed(2)  || "0.00"}
                                                    </Table.Cell>
                                                    <Table.Cell className={"responsive alignRight"} ></Table.Cell>
                                                    <Table.Cell className={"responsive alignRight"} ></Table.Cell>
                                                </Table.Row>
                                            </>)
                                        }

                                        <Table.Row style={{backgroundColor: "rgb(249, 250, 251)", color: "rgba(0,0,0,.87)"}}>

                                            <Table.Cell className={"responsive alignRight"} colspan={4}>
                                                <b>{t("Sales.sum_article")} ({row__.sorteNr2 + row__.farbeNr}):</b>
                                            </Table.Cell>
                                            <Table.Cell></Table.Cell>
                                            <Table.Cell></Table.Cell>
                                            <Table.Cell className={"responsive alignRight"}>
                                                {row__.gesamtAnz}
                                            </Table.Cell>
                                            <Table.Cell className={"responsive alignRight"} >Ø {( ((row__.gesamtWert + 0.0001).toFixed(2)/row__.gesamtAnz) + 0.0001).toFixed(2)}</Table.Cell>
                                            <Table.Cell className={"responsive alignRight"}>
                                                {(row__.gesamtWert + 0.0001).toFixed(2)  || "0.00"}
                                            </Table.Cell>
                                            <Table.Cell className={"responsive alignRight"} ></Table.Cell>
                                            <Table.Cell className={"responsive alignRight"} ></Table.Cell>
                                        </Table.Row>
                                    </>)
                                }

                                <Table.Row style={{backgroundColor: "rgb(249, 250, 251)", color: "rgba(0,0,0,.87)"}}>

                                    <Table.Cell className={"responsive alignRight"} colspan={3}>
                                        <b>{t("Sales.sum_date")} (<Moment format={t("Common.DateFormat")}>{row_.datum}</Moment>):</b>
                                    </Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell className={"responsive alignRight"}>
                                        {row_.gesamtAnz}
                                    </Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell className={"responsive alignRight"}>
                                        {(row_.gesamtWert + 0.0001).toFixed(2) || "0.00"}
                                    </Table.Cell>
                                    <Table.Cell className={"responsive alignRight"} ></Table.Cell>
                                    <Table.Cell className={"responsive alignRight"} ></Table.Cell>
                                </Table.Row>
                            </>)
                        }

                        <Table.Row style={{backgroundColor: "rgb(249, 250, 251)", color: "rgba(0,0,0,.87)"}}>

                            <Table.Cell className={"responsive alignRight"} colspan={2}>
                                <b>{t("Sales.sum_field")} ({row.geschaeftsbereich} {t("Fields." + row.geschaeftsbereich)}):</b>
                            </Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>

                            <Table.Cell className={"responsive alignRight"}>
                                {row.gesamtAnz}
                            </Table.Cell>
                            <Table.Cell className={"responsive alignRight"}>

                            </Table.Cell>
                            <Table.Cell className={"responsive alignRight"}>
                                {(row.gesamtWert + 0.0001).toFixed(2)  || "0.00"}
                            </Table.Cell>
                            <Table.Cell className={"responsive alignRight"} ></Table.Cell>
                            <Table.Cell className={"responsive alignRight"} ></Table.Cell>
                        </Table.Row>
                    </>

                )}



              <Table.Row key={"lastRow"} style={{backgroundColor: "rgb(249, 250, 251)", color: "rgba(0,0,0,.87)"}}>
                  <Table.Cell className={"responsive alignRight"}>
                      <b>{t("Sales.sum")}:</b>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell className={"responsive alignRight"}>{data.gesamtAnz}</Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell className={"responsive alignRight"}>
                   {data.gesamtWert.toFixed(2)}
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
              </Table.Row>
            </>): <></>;

        ExportContextHolder.enabled = true;
        ExportContextHolder.loadFunctionV2 = (page: number, size: number): Promise<{page: number; totalPages: number; rows: any[]}> =>{
            return new Promise(
                (resolve, reject) => {
                    // Workaround for CSV Export in sales views
                  // TODO: refactor
                    let tempRows = [];
                    try {
                      const dataRows = data.instances.flatMap((d:any) => d.instances).flatMap((d:any) => d.instances).flatMap((d:any) => d.instances).flatMap((d:any) => d.instances);
                      for(let objectRow of dataRows) {
                        let arrayRow = [];
                        for (let column of COLUMNS) {
                          const cellContent = column.printExportRender ? column.printExportRender(_get(objectRow, column.fieldName), objectRow, {}) : _get(objectRow, column.fieldName);
                          arrayRow.push(cellContent || '');
                        }
                        tempRows.push(arrayRow);
                      }
                    }catch(e) {
                      // do not crash when something does not work
                    }

                    resolve(
                        {
                            page: 0,
                            totalPages: 1,
                            rows: tempRows
                        })
                }
            );
        };
        ExportContextHolder.rowsToRender = rows;
        ExportContextHolder.routeData = [`${t("Route.Sales")} ${t("Route.SalesSupplier")}`,`${t("Sales.zuechter")}: ${props.match.params.konto}; ${t("Sales.markt")}: ${props.match.params.markt} ${props.marketName}`];
        ExportContextHolder.fields = COLUMNS.map(c => c.labelTranslationKey? t(c.labelTranslationKey) : c.label);
        ExportContextHolder.reloadHeaderFunc();

  return (
      <>
        <AnalyticsTracking page="sales/supplier/details" />
        <div className={"sticky-header"}>
          <div className={"ui container"}>
            <h3><Breadcrumb icon="right angle" sections={[
              {
                key: '1',
                as: NavLink,
                to: '/sales/supplier',
                content: `${t("Route.Sales")} ${t("Route.SalesSupplier")}`, link: true
              },
              {key: '2',
                content: `${t("Sales.zuechter")}: ${props.match.params.konto}; ${t("Sales.markt")}: ${props.match.params.markt} ${props.marketName}`,
                active: true
              },

            ]}/></h3>
            <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
            {props.dateFrom && <><strong>{t("Common.DateFrom")}:</strong> <Moment element={"span"} format={t("Common.DateFormat")}>{props.dateFrom.toISOString()}</Moment></>}
            {props.dateTo && <> <strong>{t("Common.DateTo")}:</strong> <Moment element={"span"} format={t("Common.DateFormat")}>{props.dateTo.toISOString()}</Moment></>}
            <Grid columns={3} className={"HeadingGrid"} stackable={true}
                  style={{marginBottom: '1em'}}>
              <Grid.Column width={8}>
                  <Input fluid icon={'search'} placeholder={t("Forms.Placeholder.Search")} disabled={props.loading}
                         value={props.filterObject.filter} onChange={(_,data) => props.handleFilterChange('filter', data.value)}/>
              </Grid.Column>
              <Grid.Column width={7}>
              </Grid.Column>
                <Grid.Column width={1}>
                    <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                        <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                        </div>
                    </div>
                </Grid.Column>
            </Grid>
          </div>
        </div>


        <div className={"ui container responsivewrapper"}>

            <Table>
                <Table.Header className={"sticky-header"}>
                    <Table.Row key="0">

                        { COLUMNS.map( (c, idx)=>
                            <Table.HeaderCell
                            >{c.labelTranslationKey? t(c.labelTranslationKey) : c.label}</Table.HeaderCell>
                        )}
                    </Table.Row>
                </Table.Header>

                <InfiniteScroll
                    element="tbody"
                    pageStart={0}
                    loadMore={props.loadMore}
                    hasMore={false}
                    threshold={1000}
                    useWindow={false}
                >
                    {rows}
                </InfiniteScroll>

            </Table>
          <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
            <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
            </div>
          </div>
          <div style={{height: '2em'}}/>
        </div>
      </>
  )
};

const WrappedComponent = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(SalesSupplierDetails)))))));

export default (props: RouteComponentProps<{konto: string; markt: string;}>) => {
  const [dateState, setDateState] = useState({dateFrom: undefined, dateTo: undefined} as {dateFrom?: Date; dateTo?: Date});
  const marketName = useMarketName(props.match.params.markt);

  useEffect(() => {
    const searchQuery = props.location.search;
    console.log('Reading parameter ' + searchQuery);
    if(searchQuery !== null && searchQuery!== '') {
      const parsed = queryString.parse(searchQuery);
      setDateState({
        dateFrom: parsed.dateFrom ? new Date(parsed.dateFrom) : undefined,
        dateTo: parsed.dateTo ? new Date(parsed.dateTo) : undefined
      });
    }
  }, [props.location.search]);


  const dataService = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }, size?: number): Promise<any> {


        return RestClient.get(`sales/supplier/${props.match.params.konto}/${props.match.params.markt}`, {
                    date: '',
                    filter: filter.filter,
                    dateFrom: dateState.dateFrom ? dateToIsoDateString(dateState.dateFrom) : '',
                    dateTo: dateState.dateTo ? dateToIsoDateString(dateState.dateTo) : '',
                    count: size || 50
                });
    }
  };
  return (
      <WrappedComponent
          viewName="sales_details_supplier"
          dateFrom={dateState.dateFrom}
          dateTo={dateState.dateTo}
          dataService={dataService}
          defaultSortDirection="DESC"
          defaultSortColumn="data.bewegungsDatum"
          defaultColumns={DEFAULT_COLUMNS}
          defaultFilter={{
          }}
          marketName={marketName}
          printColumns={COLUMNS}
          printPath = {[`${t("Route.Sales")} ${t("Route.SalesSupplier")}`,`${t("Sales.zuechter")}: ${props.match.params.konto}; ${t("Sales.markt")}: ${props.match.params.markt} ${marketName}`]}
      />
  );

}